export default __webpack_public_path__ + "static/media/icon-dashboard.2e6c4b07.svg";